import React, { FC } from "react"
import { Button } from "react-bootstrap"
import Notifications from "@/notifications"

const ClipboardCopyButton: FC = ({ label, content }: { label: string; content: string }) => {
  const copyLink = () => {
    navigator.clipboard.writeText(content)
    Notifications.success("Copied to clipboard", { duration: 2500 })
  }

  return (
    <Button variant="primary" onClick={copyLink}>
      <span className="fa fa-clipboard me-2" />
      {label}
    </Button>
  )
}

export default ClipboardCopyButton
